import { HisVoiceOptionsType } from './types';

export const HIS_VOICE_OPTIONS: HisVoiceOptionsType = [
  { id: 'deep_slow', title: '🌚️ Deep & slow' },
  { id: 'warm_soft', title: '☀️ Warm & Soft' },
  { id: 'doesnt_matter', title: "Doesn't matter" },
];
